import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import {
  isTelegramAppAuth,
  linkTelegramAppAfterAuth,
} from "../../lib/telegramApp";
import { AuthAlert, AuthShell, Field } from "../../components/auth/AuthShell";
import { Loader, Spinner } from "../../components/ui/Loader";

export const Login = () => {
  const { user, loading, signIn } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const telegramAuth = isTelegramAppAuth(location.search);

  if (loading) {
    return <Loader />;
  }

  if (user && !telegramAuth) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const result = await signIn(email.trim(), password);
      if (result.error) {
        setError(result.error);
      } else {
        await linkTelegramAppAfterAuth(location.search).catch(() => {});
        navigate("/dashboard", { replace: true });
      }
    } catch (e) {
      setError(e instanceof Error ? e.message : "Не вдалося увійти");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Вхід до кабінету"
      subtitle="Увійдіть, щоб керувати проєктами та бонусами"
    >
      <form onSubmit={handleSubmit} className="mt-7 flex flex-col gap-4">
        <Field
          label="Email"
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <Field
          label="Пароль"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        {error && <AuthAlert kind="error" message={error} />}
        <Link to="/forgot" className="link-brand self-end text-xs">
          Забули пароль?
        </Link>
        <button
          type="submit"
          disabled={submitting}
          className="btn-brand mt-2 w-full justify-center disabled:opacity-70"
        >
          {submitting ? (
            <>
              <Spinner className="h-4 w-4" />
              Зачекайте…
            </>
          ) : (
            "Увійти"
          )}
        </button>
      </form>
    </AuthShell>
  );
};
